/**
 * PDP — Apodemia (iurop-product.liquid)
 *
 * - Add-to-cart AJAX (form principal y upsells "Combínalo con"): POST a
 *   /cart/add.js y dispara `cart:updated` → iurop-cart-drawer.js refresca y
 *   abre el sidecart (mismo patrón que shop-the-look).
 * - Cambio de variante: actualiza precio, compare-at, cuota seQura y el
 *   estado del aviso de stock (in/low/out) desde el JSON [data-pdp-variants].
 * - "Leer más" de la descripción (solo si el texto desborda el clamp).
 * - Reseña: clic/tecla expande (además del hover de escritorio, CSS).
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2).replace('.', ',');
    // Separador de miles con punto (es-ES)
    n = n.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return n + ' €';
  }

  function addToCart(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } })
        );
      });
  }

  function init(root) {
    // ----- Grabado ("Graba tu joya") -----
    // Estado del bloque + propiedades de línea. getEngrave() devuelve
    // { properties, extraVariant } para el añadir al carrito.
    var engraveEl = root.querySelector('[data-pdp-engrave]');
    var engrave = {
      state: { text: '', font: null, format: null, symbol: null },
      el: engraveEl,
    };
    if (engraveEl) {
      var eText = engraveEl.querySelector('[data-engrave-text]');
      var setActive = function (group, btn) {
        engraveEl.querySelectorAll(group).forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', 'true');
      };
      var eCount = engraveEl.querySelector('[data-engrave-count]');
      var syncEngraveCount = function () {
        if (!eCount || !eText) return;
        var max = parseInt(eText.getAttribute('maxlength') || '20', 10);
        eCount.textContent = eText.value.length + '/' + max;
      };
      if (eText) {
        eText.addEventListener('input', function () {
          engrave.state.text = eText.value.trim();
          syncEngraveCount();
        });
        // Una sola línea: Enter no hace nada (ni salto ni submit).
        eText.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') e.preventDefault();
        });
      }
      engraveEl.querySelectorAll('[data-engrave-font]').forEach(function (b, i) {
        if (i === 0) engrave.state.font = b.getAttribute('data-value');
        b.addEventListener('click', function () {
          engrave.state.font = b.getAttribute('data-value');
          setActive('[data-engrave-font]', b);
          if (eText) eText.style.fontFamily = "'" + b.getAttribute('data-value') + "', Georgia, serif";
        });
      });
      engraveEl.querySelectorAll('[data-engrave-format]').forEach(function (b, i) {
        if (i === 0) engrave.state.format = b.getAttribute('data-value');
        b.addEventListener('click', function () {
          engrave.state.format = b.getAttribute('data-value');
          setActive('[data-engrave-format]', b);
        });
      });
      engraveEl.querySelectorAll('[data-engrave-symbol]').forEach(function (b) {
        b.addEventListener('click', function () {
          // Ilustración (imagen): selección única con toggle -> propiedad 'Símbolo'.
          if (b.hasAttribute('data-engrave-symbol-img')) {
            var wasOn = b.classList.contains('is-selected');
            engraveEl.querySelectorAll('[data-engrave-symbol-img]').forEach(function (x) {
              x.classList.remove('is-selected');
              x.setAttribute('aria-pressed', 'false');
            });
            if (!wasOn) {
              b.classList.add('is-selected');
              b.setAttribute('aria-pressed', 'true');
              engrave.state.symbol = b.getAttribute('data-value');
            } else {
              engrave.state.symbol = null;
            }
            return;
          }
          // Carácter (legacy): se inserta en el texto.
          if (!eText) return;
          var max = parseInt(eText.getAttribute('maxlength') || '20', 10);
          if (eText.value.length < max) {
            eText.value += b.getAttribute('data-value');
            engrave.state.text = eText.value.trim();
            syncEngraveCount();
            eText.focus();
          }
        });
      });
      // Tabs de categoría de ilustraciones.
      engraveEl.querySelectorAll('[data-engrave-cat]').forEach(function (b) {
        b.addEventListener('click', function () {
          var cat = b.getAttribute('data-engrave-cat');
          engraveEl.querySelectorAll('[data-engrave-cat]').forEach(function (x) {
            var on = x === b;
            x.classList.toggle('is-selected', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          engraveEl.querySelectorAll('[data-engrave-grid]').forEach(function (g) {
            g.hidden = g.getAttribute('data-engrave-grid') !== cat;
          });
        });
      });
    }
    var getEngrave = function () {
      var props = {};
      var extraVariant = null;
      var engToken = null;
      if (engraveEl && (engrave.state.text || engrave.state.symbol)) {
        var name = engraveEl.getAttribute('data-prop-text') || 'Grabado';
        if (engrave.state.text) props[name] = engrave.state.text;
        if (engrave.state.symbol) props['Símbolo'] = engrave.state.symbol;
        if (engrave.state.font) props['Fuente'] = engrave.state.font;
        if (engrave.state.format) props['Formato'] = engrave.state.format;
        var ev = engraveEl.getAttribute('data-engrave-variant');
        if (ev) {
          extraVariant = parseInt(ev, 10);
          // Token que liga la joya con su línea de servicio (+precio) en el
          // carrito: la de servicio no se borra suelta y se quita con la joya.
          engToken = 'eng-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
          props['_engrave_id'] = engToken;
        }
      }
      return { properties: Object.keys(props).length ? props : null, extraVariant: extraVariant, engToken: engToken };
    };

    // ----- Form principal (AJAX → sidecart, sin recargar) -----
    var form = root.querySelector('form[action*="/cart/add"]');
    var mainBtn = root.querySelector('[data-pdp-add-main]');
    if (form && mainBtn) {
      form.addEventListener('submit', function (e) {
        // Deja pasar el submit del botón de pago rápido (Shop Pay).
        if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
        e.preventDefault();
        var idInput = form.querySelector('[name="id"]');
        if (!idInput || mainBtn.disabled) return;
        var eng = getEngrave();
        var mainItem = { id: parseInt(idInput.value, 10), quantity: 1 };
        if (eng.properties) mainItem.properties = eng.properties;
        var items = [mainItem];
        // Producto de servicio de grabado (+precio), si está enlazado y hay texto.
        // Va marcado (_engrave_svc) y ligado a la joya (_engrave_id) para el carrito.
        if (eng.extraVariant) items.push({ id: eng.extraVariant, quantity: 1, properties: { _engrave_svc: 'yes', _engrave_id: eng.engToken } });
        // Filas "Añade una cadena/pulsera/…" (template look): suma lo elegido.
        root.querySelectorAll('[data-pdp-addon-row][data-selected-variant]').forEach(function (row) {
          items.push({ id: parseInt(row.getAttribute('data-selected-variant'), 10), quantity: 1 });
        });
        // Filas multi: cada tile marcado es una línea más del carrito.
        root.querySelectorAll('[data-pdp-addon-row][data-addon-multi] [data-addon-pick].is-selected:not([data-addon-none])').forEach(function (b) {
          items.push({ id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 });
        });
        root.querySelectorAll('[data-pdp-addon-grid] [data-grid-pick].is-selected').forEach(function (b) {
          items.push({ id: parseInt(b.getAttribute('data-variant'), 10), quantity: 1 });
        });
        mainBtn.disabled = true;
        addToCart(items)
          .catch(function () {})
          .finally(function () {
            mainBtn.disabled = false;
          });
      });
    }

    var summaryBuy = root.querySelector('[data-pdp-summary-buy]');
    if (summaryBuy && mainBtn) {
      summaryBuy.addEventListener('click', function () {
        var purchaseTarget = root.querySelector('.apodemia-pdp__variants-block, .apodemia-pdp__stones, [data-pdp-engrave], [data-pdp-bundle], [data-pdp-addon-row], [data-pdp-add-main]') || mainBtn;
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        purchaseTarget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        var focusTarget = purchaseTarget.matches('button, input, select, a[href]')
          ? purchaseTarget
          : purchaseTarget.querySelector('button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href]');
        if (focusTarget) {
          window.setTimeout(function () {
            focusTarget.focus({ preventScroll: true });
          }, reduceMotion ? 0 : 450);
        }
      });
    }

    // ----- Upsells "Combínalo con" -----
    root.querySelectorAll('[data-pdp-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        addToCart([{ id: parseInt(btn.getAttribute('data-pdp-add'), 10), quantity: 1 }])
          .catch(function () {})
          .finally(function () {
            btn.disabled = false;
          });
      });
    });

    // ----- Cambio de variante (select, pills u opciones) -----
    var select = root.querySelector('[data-pdp-variant]');
    var pills = root.querySelectorAll('[data-pdp-pill]');
    var optPicks = root.querySelectorAll('[data-pdp-opt-pick]');
    var dataEl = root.querySelector('[data-pdp-variants]');
    if (dataEl && (select || pills.length || optPicks.length)) {
      var variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { /* noop */ }
      var priceEl = root.querySelector('[data-pdp-price]');
      var compareEl = root.querySelector('[data-pdp-compare]');
      var instEl = root.querySelector('[data-pdp-installment]');
      var stockEl = root.querySelector('[data-pdp-stock]');
      var stockText = root.querySelector('[data-pdp-stock-text]');

      // Recalculo exacto de la fecha de entrega en el cliente (el SSR llega
      // cacheado por el CDN y la hora de corte necesita la hora real).
      // Reglas: antes del corte se expide ese laborable, despues el siguiente;
      // entrega = 1-2 laborables tras expedir; expedicion en viernes = solo lunes.
      if (stockText && stockText.getAttribute('data-fmt-on')) {
        try {
          var parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/Madrid', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
          }).formatToParts(new Date()).reduce(function (o, p) { o[p.type] = p.value; return o; }, {});
          var cutoff = parseInt(stockText.getAttribute('data-cutoff') || '14', 10);
          var wdFull = (stockText.getAttribute('data-weekdays-full') || '').split(',');
          var monthsNames = (stockText.getAttribute('data-months') || '').split(',');
          // Contador de dias sin hora (UTC puro para evitar DST)
          var day = Date.UTC(+parts.year, +parts.month - 1, +parts.day);
          var DAY = 86400000;
          var dowOf = function (ts) { return (new Date(ts).getUTCDay() + 6) % 7; }; // 0=lunes ... 6=domingo
          if (+parts.hour >= cutoff) day += DAY;
          while (dowOf(day) > 4) day += DAY; // dia de expedicion laborable
          var dispatchDow = dowOf(day);
          day += DAY;
          while (dowOf(day) > 4) day += DAY; // primer dia de entrega
          var from = new Date(day);
          var fecha;
          var fmt = function (tpl, map) {
            return tpl.replace(/\[(\w+)\]/g, function (_, k) { return map[k] != null ? map[k] : ''; });
          };
          if (dispatchDow === 4) {
            // Expedido en viernes: entrega solo lunes
            fecha = fmt(stockText.getAttribute('data-fmt-on'), {
              wd: wdFull[dowOf(day)], day: from.getUTCDate(), month: monthsNames[from.getUTCMonth()]
            });
          } else {
            var day2 = day + DAY;
            while (dowOf(day2) > 4) day2 += DAY;
            var to = new Date(day2);
            if (from.getUTCMonth() === to.getUTCMonth()) {
              fecha = fmt(stockText.getAttribute('data-fmt-same'), {
                from_wd: wdFull[dowOf(day)], from: from.getUTCDate(),
                to_wd: wdFull[dowOf(day2)], to: to.getUTCDate(), month: monthsNames[to.getUTCMonth()]
              });
            } else {
              fecha = fmt(stockText.getAttribute('data-fmt-cross'), {
                from_wd: wdFull[dowOf(day)], from: from.getUTCDate(), month_from: monthsNames[from.getUTCMonth()],
                to_wd: wdFull[dowOf(day2)], to: to.getUTCDate(), month_to: monthsNames[to.getUTCMonth()]
              });
            }
          }
          if (fecha) {
            stockText.setAttribute('data-fecha', fecha);
            var m = (stockEl && stockEl.className.match(/apodemia-pdp__stock--(in|low|out)/)) || null;
            var tpl0 = stockText.getAttribute('data-text-' + (m ? m[1] : 'in')) || '';
            if (tpl0.indexOf('[fecha]') !== -1) stockText.textContent = tpl0.replace('[fecha]', fecha);
          }
        } catch (e) { /* fallback: se queda la fecha SSR */ }
      }

      var findVariant = function (id) {
        return variants.find(function (x) { return String(x.id) === String(id); });
      };

      var applyVariant = function (v) {
        if (!v) return;
        if (priceEl) priceEl.textContent = formatMoney(v.price);
        if (compareEl) {
          if (v.compare > v.price) {
            compareEl.textContent = formatMoney(v.compare);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (instEl) {
          var months = parseInt(instEl.getAttribute('data-months') || '3', 10);
          instEl.textContent = formatMoney(Math.floor(v.price / months));
        }
        // Precio dinámico del botón (si está activo)
        addBasePrice = v.price;
        updateAddPrice();
        if (mainBtn) mainBtn.disabled = !v.available;
        if (stockEl && stockText) {
          var threshold = parseInt(stockEl.getAttribute('data-threshold') || '10', 10);
          var state = 'in';
          if (!v.available) state = 'out';
          else if (v.managed && v.qty > 0 && v.qty <= threshold) state = 'low';
          stockEl.classList.remove('apodemia-pdp__stock--in', 'apodemia-pdp__stock--low', 'apodemia-pdp__stock--out');
          stockEl.classList.add('apodemia-pdp__stock--' + state);
          var tpl = stockText.getAttribute('data-text-' + state) || '';
          stockText.textContent = tpl.replace('[fecha]', stockText.getAttribute('data-fecha') || '');
        }
        // Notifica al sticky add-to-cart (precio / ahorro / anuncio).
        document.dispatchEvent(new CustomEvent('pdp:variant', { detail: v }));
      };

      if (select) {
        select.addEventListener('change', function () {
          // Si el selector vive fuera del form (bloque independiente), volcar
          // la selección al input name=id del form.
          var formInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
          if (formInput && formInput !== select) formInput.value = select.value;
          applyVariant(findVariant(select.value));
        });
      }

      // Selector por opciones (template anillos: Piedra swatches + Talla pills)
      if (optPicks.length) {
        var optInput = root.querySelector('[data-pdp-variant-input]');
        var current = optInput ? findVariant(optInput.value) : null;
        var selectedOpts = current && current.options ? current.options.slice() : [];

        optPicks.forEach(function (p) {
          p.addEventListener('click', function () {
            var oi = parseInt(p.getAttribute('data-opt'), 10);
            var value = p.getAttribute('data-value');
            if (p.classList.contains('is-selected')) return;
            // Marca visual dentro del mismo grupo de opción
            optPicks.forEach(function (o) {
              if (parseInt(o.getAttribute('data-opt'), 10) === oi) {
                o.classList.remove('is-selected');
                o.setAttribute('aria-pressed', 'false');
              }
            });
            p.classList.add('is-selected');
            p.setAttribute('aria-pressed', 'true');
            var valEl = root.querySelector('[data-pdp-opt-value="' + oi + '"]');
            if (valEl) valEl.textContent = value;
            selectedOpts[oi] = value;
            // Resuelve la variante que combina TODAS las opciones elegidas
            var v = variants.find(function (x) {
              if (!x.options) return false;
              for (var i = 0; i < selectedOpts.length; i++) {
                if (String(x.options[i]) !== String(selectedOpts[i])) return false;
              }
              return true;
            });
            if (v) {
              if (optInput) optInput.value = v.id;
              applyVariant(v);
            } else if (mainBtn) {
              // Combinación inexistente → no se puede comprar
              mainBtn.disabled = true;
            }
          });
        });
      }

      // Pills (template pendientes: Pareja | Unidad)
      if (pills.length) {
        var pillInput = root.querySelector('[data-pdp-variant-input]');
        var pillValue = root.querySelector('[data-pdp-variant-value]');
        pills.forEach(function (p) {
          p.addEventListener('click', function () {
            if (p.disabled || p.classList.contains('is-selected')) return;
            pills.forEach(function (o) {
              o.classList.remove('is-selected');
              o.setAttribute('aria-pressed', 'false');
            });
            p.classList.add('is-selected');
            p.setAttribute('aria-pressed', 'true');
            if (pillInput) pillInput.value = p.getAttribute('data-variant');
            if (pillValue) pillValue.textContent = p.getAttribute('data-title');
            applyVariant(findVariant(p.getAttribute('data-variant')));
          });
        });
      }
    }

    // ----- Guía de tallas (modal) -----
    var sgModal = root.querySelector('[data-pdp-sizeguide]');
    if (sgModal) {
      root.querySelectorAll('[data-pdp-sizeguide-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sgModal.hidden = false;
        });
      });
      sgModal.querySelectorAll('[data-pdp-sizeguide-close]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          sgModal.hidden = true;
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !sgModal.hidden) sgModal.hidden = true;
      });
    }

    // ----- Precio dinámico del botón (base + joyas elegidas) -----
    var addPriceEl = root.querySelector('[data-pdp-add-price]');
    var addBasePrice = addPriceEl ? parseInt(addPriceEl.getAttribute('data-base'), 10) || 0 : 0;
    var updateAddPrice = function () {
      if (!addPriceEl) return;
      var total = addBasePrice;
      root.querySelectorAll('[data-pdp-addon-row][data-selected-variant]').forEach(function (row) {
        total += parseInt(row.getAttribute('data-selected-price'), 10) || 0;
      });
      // Filas multi: suma cada tile marcado (estas filas no llevan data-selected-variant).
      root.querySelectorAll('[data-pdp-addon-row][data-addon-multi] [data-addon-pick].is-selected:not([data-addon-none])').forEach(function (b) {
        total += parseInt(b.getAttribute('data-price'), 10) || 0;
      });
      root.querySelectorAll('[data-pdp-addon-grid] [data-grid-pick].is-selected').forEach(function (b) {
        total += parseInt(b.getAttribute('data-price'), 10) || 0;
      });
      addPriceEl.textContent = formatMoney(total);
    };

    // ----- Pestañas de categoría de charms ("crea tu joya"): filtran los thumbs
    // por data-addon-cat. Oculta las pestañas sin charms y activa la primera con
    // contenido. La selección multi persiste al cambiar de pestaña. -----
    root.querySelectorAll('[data-pdp-addon-row][data-addon-cats]').forEach(function (row) {
      var tabs = Array.prototype.slice.call(row.querySelectorAll('[data-addon-cat-tab]'));
      var thumbs = Array.prototype.slice.call(row.querySelectorAll('[data-addon-cat]'));
      if (!tabs.length || !thumbs.length) return;
      var noneBtn = row.querySelector('[data-addon-none]');
      var showCat = function (cat) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-addon-cat-tab') === cat;
          t.classList.toggle('is-selected', on);
          t.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        thumbs.forEach(function (b) {
          b.hidden = b.getAttribute('data-addon-cat') !== cat;
        });
        if (noneBtn) noneBtn.hidden = false; // "Ninguno" siempre visible
      };
      var firstWith = null;
      tabs.forEach(function (t) {
        var cat = t.getAttribute('data-addon-cat-tab');
        var has = thumbs.some(function (b) { return b.getAttribute('data-addon-cat') === cat; });
        t.hidden = !has;
        if (has && !firstWith) firstWith = cat;
        t.addEventListener('click', function () { showCat(cat); });
      });
      if (firstWith) showCat(firstWith);
    });

    // ----- "Ver más" de los selectores de joyas: despliega los thumbs ocultos
    // hacia abajo (la fila pasa a rejilla envuelta; CSS .is-expanded). -----
    root.querySelectorAll('[data-addon-expand]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var addon = btn.closest('.apodemia-pdp__addon');
        var strip = addon && addon.querySelector('.apodemia-pdp__addon-strip');
        if (!strip) return;
        var open = strip.classList.toggle('is-expanded');
        strip.querySelectorAll('[data-addon-extra]').forEach(function (t) { t.hidden = !open; });
        btn.textContent = btn.getAttribute(open ? 'data-less' : 'data-more');
      });
    });

    // ----- Filas "Añade una cadena/pulsera/…" (template look) -----
    root.querySelectorAll('[data-pdp-addon-row]').forEach(function (row) {
      var nameEl = row.querySelector('[data-addon-name]');
      var priceEl = row.querySelector('[data-addon-price]');
      var items = row.querySelectorAll('[data-addon-pick]');

      // CRO: el badge conserva el "10% OFF"; junto a él, en un elemento aparte
      // ([data-addon-save]), se muestra el ahorro EN € del charm elegido. El %
      // se lee una vez del texto del badge. Sin selección, teaser con el primer
      // charm. Ambos los oculta el ajuste show_pack_discounts (Liquid), así que
      // si no existe el badge no hay nada que calcular.
      var badgeEl = row.querySelector('.apodemia-pdp__bundle-badge');
      var saveEl = row.querySelector('[data-addon-save]');
      var savePct = 0;
      if (badgeEl) {
        var pctMatch = (badgeEl.textContent || '').match(/(\d+(?:[.,]\d+)?)\s*%/);
        if (pctMatch) savePct = parseFloat(pctMatch[1].replace(',', '.'));
      }
      var firstCharm = row.querySelector('[data-addon-pick]:not([data-addon-none])');
      var teaserPrice = firstCharm ? (parseInt(firstCharm.getAttribute('data-price'), 10) || 0) : 0;
      var showSave = function (cents) {
        if (!saveEl || savePct <= 0) return;
        var base = cents > 0 ? cents : teaserPrice;
        var save = base > 0 ? Math.round(base * savePct / 100) : 0;
        if (save > 0) {
          saveEl.textContent = (saveEl.getAttribute('data-t-save') || 'Ahorras') + ' ' + formatMoney(save);
          saveEl.hidden = false;
        } else {
          saveEl.hidden = true;
        }
      };

      var select = function (btn) {
        items.forEach(function (b) {
          b.classList.remove('is-selected');
          b.setAttribute('aria-pressed', 'false');
        });
        if (btn && btn.hasAttribute('data-addon-none')) {
          // "Sin charm": queda visualmente marcado, pero NO añade nada al carrito.
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          row.removeAttribute('data-selected-variant');
          row.removeAttribute('data-selected-price');
          if (nameEl) nameEl.hidden = true;
          if (priceEl) priceEl.hidden = true;
          showSave(0);
          updateAddPrice();
          return;
        }
        if (btn) {
          btn.classList.add('is-selected');
          btn.setAttribute('aria-pressed', 'true');
          row.setAttribute('data-selected-variant', btn.getAttribute('data-variant'));
          row.setAttribute('data-selected-price', btn.getAttribute('data-price'));
          if (nameEl) {
            nameEl.textContent = btn.getAttribute('data-title');
            nameEl.hidden = false;
          }
          if (priceEl) {
            priceEl.textContent = '+' + formatMoney(parseInt(btn.getAttribute('data-price'), 10));
            priceEl.hidden = false;
          }
          showSave(parseInt(btn.getAttribute('data-price'), 10) || 0);
        } else {
          row.removeAttribute('data-selected-variant');
          row.removeAttribute('data-selected-price');
          if (nameEl) nameEl.hidden = true;
          if (priceEl) priceEl.hidden = true;
          showSave(0);
        }
        updateAddPrice();
      };

      var noneBtn = row.querySelector('[data-addon-none]');

      // ----- Fila MULTI (data-addon-multi): cada tile alterna; se pueden
      // llevar varios (p. ej. varios charms). "Ninguno" limpia todo y queda
      // marcado cuando no hay nada elegido. El carrito y el precio del botón
      // suman todas las marcadas (ver submit y updateAddPrice).
      if (row.hasAttribute('data-addon-multi')) {
        var syncMulti = function () {
          var sel = Array.prototype.slice.call(row.querySelectorAll('[data-addon-pick].is-selected:not([data-addon-none])'));
          if (noneBtn) {
            var noneOn = sel.length === 0;
            noneBtn.classList.toggle('is-selected', noneOn);
            noneBtn.setAttribute('aria-pressed', noneOn ? 'true' : 'false');
          }
          var sum = 0;
          var names = sel.map(function (b) {
            sum += parseInt(b.getAttribute('data-price'), 10) || 0;
            return b.getAttribute('data-title');
          });
          if (nameEl) {
            nameEl.textContent = names.join(' + ');
            nameEl.hidden = names.length === 0;
          }
          if (priceEl) {
            priceEl.textContent = '+' + formatMoney(sum);
            priceEl.hidden = sum === 0;
          }
          showSave(sum);
          updateAddPrice();
        };
        items.forEach(function (b) {
          b.addEventListener('click', function () {
            if (b === noneBtn) {
              row.querySelectorAll('[data-addon-pick].is-selected').forEach(function (x) {
                x.classList.remove('is-selected');
                x.setAttribute('aria-pressed', 'false');
              });
            } else {
              var on = b.classList.toggle('is-selected');
              b.setAttribute('aria-pressed', on ? 'true' : 'false');
            }
            syncMulti();
          });
        });
        syncMulti(); // estado inicial ("Ninguno" marcado si existe)
        return;
      }

      items.forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.classList.contains('is-selected')) {
            // Desmarcar la seleccionada: si la fila tiene "Ninguno", vuelve a él
            // (dupla addon/Ninguno); "Ninguno" ya marcado se queda como está.
            if (b === noneBtn) return;
            select(noneBtn || null);
          } else {
            select(b);
          }
        });
      });

      // Al entrar: "Ninguno" marcado por defecto si existe (y el badge muestra
      // el ahorro en € del primer charm como reclamo). Sin preselección, igual
      // pintamos el reclamo para que el badge nunca se quede en "10% OFF".
      if (row.hasAttribute('data-addon-preselect') && items.length) select(noneBtn || items[0]);
      else showSave(0);
    });

    // ----- Grid "Añade más charms" (multi-selección, template look) -----
    root.querySelectorAll('[data-pdp-addon-grid] [data-grid-pick]').forEach(function (b) {
      b.addEventListener('click', function () {
        var sel = b.classList.toggle('is-selected');
        b.setAttribute('aria-pressed', sel ? 'true' : 'false');
        updateAddPrice();
      });
    });

    // ----- "Completa tu compra" (bundle) -----
    var bundle = root.querySelector('[data-pdp-bundle]');
    if (bundle) {
      var bData = { base: null, candidates: [], remove_label: 'Quitar' };
      try { bData = JSON.parse(bundle.querySelector('[data-bundle-data]').textContent); } catch (e) { /* noop */ }
      // Dedup por id
      var seen = {};
      bData.candidates = (bData.candidates || []).filter(function (c) {
        if (!c || !c.variant || seen[c.id]) return false;
        seen[c.id] = true;
        return true;
      });

      var picker = bundle.querySelector('[data-bundle-picker]');
      var list = bundle.querySelector('[data-bundle-list]');
      var addBtn = bundle.querySelector('[data-bundle-add]');
      var slots = { 1: null, 2: null }; // slot → candidate
      var defaults = {
        1: bundle.querySelector('[data-bundle-label="1"]') ? bundle.querySelector('[data-bundle-label="1"]').textContent : '',
        2: bundle.querySelector('[data-bundle-label="2"]') ? bundle.querySelector('[data-bundle-label="2"]').textContent : '',
      };
      var activeSlot = null;

      var renderSlot = function (n) {
        var btn = bundle.querySelector('[data-bundle-open="' + n + '"]');
        var label = bundle.querySelector('[data-bundle-label="' + n + '"]');
        var c = slots[n];
        if (c) {
          btn.innerHTML = c.image
            ? '<img class="apodemia-pdp__bundle-img" src="' + c.image + '" alt="">'
            : '<span class="apodemia-pdp__bundle-plus" aria-hidden="true"></span>';
          if (label) label.textContent = c.title;
        } else {
          btn.innerHTML = '<span class="apodemia-pdp__bundle-plus" aria-hidden="true"></span>';
          if (label) label.textContent = defaults[n];
        }
      };

      var updateAdd = function () {
        var count = (slots[1] ? 1 : 0) + (slots[2] ? 1 : 0);
        addBtn.hidden = count === 0;
        addBtn.textContent = addBtn.getAttribute(count >= 2 ? 'data-label-2' : 'data-label-1');
      };

      var closePicker = function () {
        picker.hidden = true;
        activeSlot = null;
      };

      var openPicker = function (n) {
        activeSlot = n;
        list.innerHTML = '';
        // Opción "quitar" si el slot ya tiene joya
        if (slots[n]) {
          var rm = document.createElement('li');
          rm.innerHTML = '<button type="button" class="apodemia-pdp__bundle-item apodemia-pdp__bundle-item--remove"><span class="apodemia-pdp__bundle-item-title">' + bData.remove_label + '</span></button>';
          rm.firstChild.addEventListener('click', function () {
            slots[n] = null;
            renderSlot(n);
            updateAdd();
            closePicker();
          });
          list.appendChild(rm);
        }
        var otherId = slots[n === 1 ? 2 : 1] ? slots[n === 1 ? 2 : 1].id : null;
        bData.candidates.forEach(function (c) {
          if (otherId && c.id === otherId) return; // no repetir la misma joya
          var li = document.createElement('li');
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'apodemia-pdp__bundle-item';
          b.innerHTML = (c.image ? '<img src="' + c.image + '" alt="" loading="lazy">' : '') +
            '<span class="apodemia-pdp__bundle-item-title"></span>' +
            '<span class="apodemia-pdp__bundle-item-price">' + formatMoney(c.price) + '</span>';
          b.querySelector('.apodemia-pdp__bundle-item-title').textContent = c.title;
          b.addEventListener('click', function () {
            slots[n] = c;
            renderSlot(n);
            updateAdd();
            closePicker();
          });
          li.appendChild(b);
          list.appendChild(li);
        });
        picker.hidden = false;
      };

      bundle.querySelectorAll('[data-bundle-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var n = parseInt(btn.getAttribute('data-bundle-open'), 10);
          if (activeSlot === n && !picker.hidden) {
            closePicker();
          } else {
            openPicker(n);
          }
        });
      });
      var closeBtn = bundle.querySelector('[data-bundle-close]');
      if (closeBtn) closeBtn.addEventListener('click', closePicker);

      addBtn.addEventListener('click', function () {
        var idInput = root.querySelector('form[action*="/cart/add"] [name="id"]');
        var items = [];
        if (idInput) items.push({ id: parseInt(idInput.value, 10), quantity: 1 });
        [1, 2].forEach(function (n) {
          if (slots[n]) items.push({ id: slots[n].variant, quantity: 1 });
        });
        if (!items.length) return;
        addBtn.disabled = true;
        addToCart(items)
          .catch(function () {})
          .finally(function () {
            addBtn.disabled = false;
          });
      });
    }

    // ----- "Háztelo gratis en tienda" — modal con el widget nativo de
    // Cowlendar (iframe a su página de reserva). El iframe se carga la 1ª vez
    // que se abre el modal (no en cada PDP). Cowlendar muestra solo las tiendas
    // de la app y registra la cita real.
    var svc = root.querySelector('[data-pdp-storesvc]');
    if (svc) {
      var svcModal = svc.querySelector('[data-storesvc-modal]');
      var svcLoading = svc.querySelector('[data-storesvc-loading]');
      var svcWidget = svc.querySelector('.cowlendar-section');

      var svcOpen = function () {
        svcModal.hidden = false;
        document.body.classList.add('apodemia-storesvc-open');
        // Cowlendar hidrata el div al cargar la pagina; ocultamos el "Cargando"
        // cuando ya ha inyectado contenido.
        if (svcLoading) {
          if (svcWidget && svcWidget.childElementCount > 0) svcLoading.hidden = true;
          else {
            var tries = 0;
            var iv = setInterval(function () {
              tries++;
              if (svcWidget && svcWidget.childElementCount > 0) { svcLoading.hidden = true; clearInterval(iv); }
              if (tries > 40) clearInterval(iv); // ~8s
            }, 200);
          }
        }
      };
      var svcClose = function () {
        svcModal.hidden = true;
        document.body.classList.remove('apodemia-storesvc-open');
      };

      svc.querySelectorAll('[data-storesvc-open]').forEach(function (b) {
        b.addEventListener('click', svcOpen);
      });
      svc.querySelectorAll('[data-storesvc-close]').forEach(function (b) {
        b.addEventListener('click', svcClose);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !svcModal.hidden) svcClose();
      });
    }

    var gal = root.querySelector('[data-pdp-gallery]');

    // ----- Barra de progreso de la galería (móvil) -----
    var gTrack = root.querySelector('[data-pdp-gallery-progress]');
    var gThumb = root.querySelector('[data-pdp-gallery-thumb]');
    if (gal && gTrack && gThumb) {
      var galleryItems = Array.prototype.slice.call(gal.querySelectorAll('.apodemia-pdp__media'));
      var updateGalleryHeight = function () {
        if (!window.matchMedia('(max-width: 989px)').matches) {
          gal.style.height = '';
          return;
        }
        if (!galleryItems.length) return;
        var center = gal.scrollLeft + gal.clientWidth / 2;
        var active = galleryItems[0];
        var nearest = Infinity;
        galleryItems.forEach(function (item) {
          var distance = Math.abs(item.offsetLeft + item.offsetWidth / 2 - center);
          if (distance < nearest) {
            nearest = distance;
            active = item;
          }
        });
        gal.style.height = active.offsetHeight + 'px';
      };
      var updateGallery = function () {
        updateGalleryHeight();
        var max = gal.scrollWidth - gal.clientWidth;
        if (max <= 0) {
          gTrack.hidden = true;
          return;
        }
        gTrack.hidden = false;
        var frac = gal.clientWidth / gal.scrollWidth;
        gThumb.style.width = Math.max(frac * 100, 10) + '%';
        var x = (gal.scrollLeft / max) * (gTrack.clientWidth - gThumb.offsetWidth);
        gThumb.style.transform = 'translateX(' + x + 'px)';
      };
      gal.addEventListener('scroll', updateGallery, { passive: true });
      window.addEventListener('resize', updateGallery);
      galleryItems.forEach(function (item) {
        var media = item.querySelector('img, video');
        if (media) media.addEventListener('load', updateGallery, { once: true });
      });
      updateGallery();
    }

    // ----- "Leer más" de la descripción (solo si desborda) -----
    var clamp = root.querySelector('[data-pdp-clamp]');
    var readmore = root.querySelector('[data-pdp-readmore]');
    if (clamp && readmore) {
      if (clamp.scrollHeight > clamp.clientHeight + 4) {
        readmore.hidden = false;
        readmore.addEventListener('click', function () {
          var open = clamp.classList.toggle('is-open');
          readmore.textContent = readmore.getAttribute(open ? 'data-less' : 'data-more');
        });
      }
    }

    // ----- Reseña expandible (clic / teclado; hover lo cubre el CSS) -----
    var review = root.querySelector('[data-pdp-review]');
    if (review) {
      var toggle = function () { review.classList.toggle('is-open'); };
      review.addEventListener('click', toggle);
      review.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    }

    // ----- "Ver en idioma original" (solo en locales != es con original) -----
    var reviewOrigBtn = root.querySelector('[data-pdp-review-orig]');
    if (review && reviewOrigBtn) {
      var showingOriginal = false;
      var translated = review.getAttribute('data-review-translated') || review.textContent;
      var original = review.getAttribute('data-review-original') || '';
      reviewOrigBtn.addEventListener('click', function () {
        showingOriginal = !showingOriginal;
        review.textContent = showingOriginal ? original : translated;
        reviewOrigBtn.textContent = showingOriginal
          ? (reviewOrigBtn.getAttribute('data-label-translated') || reviewOrigBtn.textContent)
          : (reviewOrigBtn.getAttribute('data-label-original') || reviewOrigBtn.textContent);
        review.classList.remove('is-open'); // re-recorta al cambiar de texto
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-pdp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init al recargar la sección en el theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-pdp]');
    if (root) init(root);
  });
})();

/* ==========================================================================
 * Columna sticky del PDP — la MÁS CORTA se queda fija (Apodemia)
 * En escritorio (2 columnas) se compara el alto de galería (izquierda) vs info
 * (derecha) y se marca la más corta con .is-pdp-sticky (CSS: position:sticky).
 * Así, al scrollear la columna larga, la corta acompaña. En móvil (1 columna)
 * no aplica. Autónomo; se recalcula al redimensionar y al cargar imágenes.
 * ========================================================================== */
(function () {
  'use strict';
  var MOBILE = 990; // <=989 apila (sin sticky)

  function headerH() {
    var h = document.querySelector('.apodemia-header-wrap');
    return h ? Math.round(h.getBoundingClientRect().height) : 0;
  }

  function apply(inner) {
    var left = inner.querySelector('.apodemia-pdp__left');
    var right = inner.querySelector('.apodemia-pdp__right');
    if (!left || !right) return;
    left.classList.remove('is-pdp-sticky');
    right.classList.remove('is-pdp-sticky');
    inner.style.removeProperty('--pdp-sticky-top');
    if (window.innerWidth < MOBILE) return; // móvil: apilado, sin sticky

    // Lado forzado desde el ajuste de la sección (look: galería fija).
    var section = inner.closest('.apodemia-pdp');
    var side = (section && section.getAttribute('data-pdp-sticky-side')) || 'auto';

    var target;
    if (side === 'left') {
      target = left;
    } else if (side === 'right') {
      target = right;
    } else {
      // Auto: la más corta. Si son casi iguales no fijamos nada (evita saltos).
      var lh = left.getBoundingClientRect().height;
      var rh = right.getBoundingClientRect().height;
      if (Math.abs(lh - rh) < 24) return;
      target = lh < rh ? left : right;
    }
    inner.style.setProperty('--pdp-sticky-top', (headerH() + 16) + 'px');
    target.classList.add('is-pdp-sticky');
  }

  function boot() {
    var inners = document.querySelectorAll('.apodemia-pdp__inner');
    if (!inners.length) return;
    inners.forEach(apply);
  }

  function schedule() {
    window.requestAnimationFrame(boot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule); // tras cargar imágenes (altura real)
  var t = 0;
  window.addEventListener('resize', function () {
    window.clearTimeout(t);
    t = window.setTimeout(schedule, 150);
  });
  document.addEventListener('shopify:section:load', schedule);
})();

// ============================================================
// Visor "Ver en detalle" de la galería PDP
// Clic/Enter en una imagen -> visor a pantalla completa.
// Escritorio: lupa circular que sigue el cursor (x2.5).
// Móvil: pellizco para zoom (x1-x4), arrastre para mover y
// doble tap para alternar x1/x2.5. Esc/flechas en teclado.
// ============================================================
(function () {
  'use strict';

  function init() {
    var root = document.querySelector('[data-pdp-zoom]');
    var dataEl = document.querySelector('[data-pdp-zoom-data]');
    if (!root || !dataEl || root.hasAttribute('data-zoom-init')) return;
    root.setAttribute('data-zoom-init', '');

    // La galería vive en una columna sticky (stacking context propio): el visor
    // se saca a <body> para que su z-index compita a nivel de documento.
    document.body.appendChild(root);

    var imgs = [];
    try { imgs = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!imgs.length) return;

    var stage = root.querySelector('[data-pdp-zoom-stage]');
    var img = root.querySelector('[data-pdp-zoom-img]');
    var lens = root.querySelector('[data-pdp-zoom-lens]');
    var count = root.querySelector('[data-pdp-zoom-count]');
    var btnClose = root.querySelector('[data-pdp-zoom-close]');
    var btnPrev = root.querySelector('[data-pdp-zoom-prev]');
    var btnNext = root.querySelector('[data-pdp-zoom-next]');
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
    var LENS = 200; // diámetro de la lupa (px)
    var Z = 2.5;    // aumento de la lupa / doble tap

    var idx = 0;
    var opener = null;

    if (imgs.length < 2) {
      btnPrev.hidden = true;
      btnNext.hidden = true;
      if (count) count.hidden = true;
    }

    // ---- estado táctil (transform sobre la imagen) ----
    var scale = 1, tx = 0, ty = 0;
    function applyT() { img.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')'; }
    function resetT() { scale = 1; tx = 0; ty = 0; applyT(); }
    function clampPan() {
      var r = stage.getBoundingClientRect();
      var mx = Math.max(0, (img.clientWidth * scale - r.width) / 2);
      var my = Math.max(0, (img.clientHeight * scale - r.height) / 2);
      tx = Math.min(mx, Math.max(-mx, tx));
      ty = Math.min(my, Math.max(-my, ty));
    }
    // Re-escala manteniendo fijo el punto (px,py) de la pantalla.
    function setScaleAround(px, py, ns) {
      var r = img.getBoundingClientRect();
      var cx = r.left + r.width / 2;
      var cy = r.top + r.height / 2;
      var ux = (px - cx) / scale;
      var uy = (py - cy) / scale;
      tx += (px - ux * ns) - cx;
      ty += (py - uy * ns) - cy;
      scale = ns;
      clampPan();
      applyT();
    }

    function show(i) {
      idx = (i + imgs.length) % imgs.length;
      img.src = imgs[idx].src;
      img.alt = imgs[idx].alt || '';
      resetT();
      lens.hidden = true;
      if (count) count.textContent = (idx + 1) + ' / ' + imgs.length;
    }
    function open(i, from) {
      opener = from || null;
      show(i);
      root.hidden = false;
      document.documentElement.setAttribute('data-zoom-open', 'true');
      btnClose.focus();
    }
    function close() {
      root.hidden = true;
      document.documentElement.removeAttribute('data-zoom-open');
      if (opener && opener.focus) opener.focus();
    }

    // Abrir desde la galería en DOS pasos: el primer clic/tap muestra la
    // pastilla "Ver en detalle" (is-hint-open); el segundo (en la imagen o en
    // la pastilla) abre el visor. Igual en escritorio y móvil.
    function closeHints(except) {
      document.querySelectorAll('[data-pdp-zoom-open].is-hint-open').forEach(function (o) {
        if (o !== except) o.classList.remove('is-hint-open');
      });
    }
    document.querySelectorAll('[data-pdp-zoom-open]').forEach(function (el) {
      function go() { open(parseInt(el.getAttribute('data-pdp-zoom-open'), 10) || 0, el); }
      el.addEventListener('click', function () {
        if (!el.classList.contains('is-hint-open')) {
          closeHints(el);
          el.classList.add('is-hint-open');
          return;
        }
        go();
      });
      // Teclado: Enter/Espacio abren directamente (sin paso intermedio).
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
      });
    });
    // Clic/tap fuera de la galería: se esconde la pastilla.
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pdp-zoom-open]')) closeHints(null);
    });

    btnClose.addEventListener('click', close);
    btnPrev.addEventListener('click', function () { show(idx - 1); });
    btnNext.addEventListener('click', function () { show(idx + 1); });
    // Clic en el fondo (fuera de la imagen) cierra.
    root.addEventListener('click', function (e) {
      if (e.target === root || e.target === stage) close();
    });
    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'ArrowRight') show(idx + 1);
    });

    // ---- Lupa (escritorio) ----
    function moveLens(e) {
      var r = img.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) { lens.hidden = true; return; }
      lens.hidden = false;
      lens.style.left = (e.clientX - LENS / 2) + 'px';
      lens.style.top = (e.clientY - LENS / 2) + 'px';
      lens.style.backgroundImage = 'url("' + imgs[idx].src + '")';
      lens.style.backgroundSize = (r.width * Z) + 'px ' + (r.height * Z) + 'px';
      lens.style.backgroundPosition = (LENS / 2 - x * Z) + 'px ' + (LENS / 2 - y * Z) + 'px';
    }
    stage.addEventListener('mousemove', function (e) { if (fine.matches) moveLens(e); });
    stage.addEventListener('mouseleave', function () { lens.hidden = true; });

    // ---- Táctil (móvil): pellizco + arrastre + doble tap ----
    function dist(t) { var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY; return Math.hypot(dx, dy); }
    function mid(t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; }
    var pDist = 0, panStart = null, lastTap = 0;

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        pDist = dist(e.touches);
        panStart = null;
      } else if (e.touches.length === 1) {
        var t = e.touches[0];
        var now = Date.now();
        if (now - lastTap < 300) { // doble tap: alterna zoom
          e.preventDefault();
          if (scale > 1) resetT();
          else setScaleAround(t.clientX, t.clientY, Z);
          lastTap = 0;
          return;
        }
        lastTap = now;
        panStart = { x: t.clientX, y: t.clientY, tx: tx, ty: ty };
      }
    }, { passive: false });

    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pDist) {
        e.preventDefault();
        var d = dist(e.touches);
        var m = mid(e.touches);
        setScaleAround(m.x, m.y, Math.min(4, Math.max(1, scale * (d / pDist))));
        pDist = d;
      } else if (e.touches.length === 1 && panStart && scale > 1) {
        e.preventDefault(); // no arrastrar la página de fondo
        var t = e.touches[0];
        tx = panStart.tx + (t.clientX - panStart.x);
        ty = panStart.ty + (t.clientY - panStart.y);
        clampPan();
        applyT();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function (e) {
      if (e.touches.length < 2) pDist = 0;
      if (!e.touches.length) panStart = null;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
